import React from "react";

const InVehicleRecordingMenu = ({ PageName, IconName }) => {
  const Color = PageName === IconName ? "#4C34AD" : "#fff";
  return (
    <div className="ml-0 flex items-center gap-4">
        <svg id="Group_47742" data-name="Group 47742" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
          <path id="Path_94245" data-name="Path 94245" d="M12.015,23.857a1,1,0,0,0,0-1.714l-5-3A1,1,0,0,0,5.5,20v6a1,1,0,0,0,1.515.857l5-3ZM22.4,8.2a1,1,0,0,0,0,1.6l8,6A1,1,0,0,0,32,15V3a1,1,0,0,0-1.6-.8Z" fill="#fff" fill-rule="evenodd"/>
          <path id="Path_94246" data-name="Path 94246" d="M9,14a9,9,0,1,0,9,9A9,9,0,0,0,9,14Zm0,2a7,7,0,1,1-7,7A7,7,0,0,1,9,16Z" fill="#fff" fill-rule="evenodd"/>
          <path id="Path_94247" data-name="Path 94247" d="M4.04,15.491A3.1,3.1,0,0,1,4,15V3A3,3,0,0,1,7,0H21a3,3,0,0,1,3,3V15a3,3,0,0,1-3,3H16s-5.337-3-7-3c-1.832,0-3.538-.451-4.96.491C4.142,16.1,1.606,17.1,4.04,15.491Z" fill="#fff" fill-rule="evenodd"/>
      </svg>
      <p className="font-bold text-white">Recording Management</p>
    </div>
  );
};

export default InVehicleRecordingMenu;
